import { render, staticRenderFns } from "./CollapsibleFilters.vue?vue&type=template&id=c540e73e&scoped=true&"
import script from "./CollapsibleFilters.vue?vue&type=script&lang=js&"
export * from "./CollapsibleFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleFilters.vue?vue&type=style&index=0&id=c540e73e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c540e73e",
  null
  
)

export default component.exports